import { cva } from "class-variance-authority";

export const historyEntryRowStyles = {
  row: "relative flex-nowrap gap-3 rounded-none px-4 py-2.5 hover:bg-panel-hover",
  renameRow: "gap-2 rounded-none bg-panel-hover px-4 py-2.5",
  deleteRow: "gap-2 rounded-none bg-destructive/10 px-4 py-2.5",
  selectBtn: "flex min-w-0 flex-1 items-center text-left",
  entryContent: "min-w-0 gap-0",
  entryText: "truncate text-xs leading-snug text-secondary-foreground",
  trailing: "relative flex shrink-0 items-center justify-end",
  icon: "h-3.5 w-3.5",
  menuContent: "min-w-30",
  menuItem: "gap-2 px-2.5 py-1.5 text-xs [&_svg:not([class*='size-'])]:size-3",
  input:
    "min-w-0 flex-1 rounded-md border border-ring-border bg-background px-2 py-1 text-xs text-secondary-foreground ring-1 ring-ring outline-none disabled:opacity-60",
  confirmLabel: "min-w-0 flex-1 truncate text-xs text-destructive",
  error: "w-full pt-1 text-xxs text-destructive",
};

export const historyEntryIconBtn = cva(
  "shrink-0 rounded p-1 disabled:pointer-events-none disabled:opacity-40",
  {
    variants: {
      tone: {
        neutral: "text-subtle hover:bg-panel-hover",
        primary: "text-primary hover:bg-accent",
        danger: "text-destructive hover:bg-destructive/20",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

/** Timestamp and options button cross-fade within one trailing slot, so the menu never reflows the row. */
export const historyEntryTimestamp = cva("text-2xs tabular-nums text-mid transition-opacity", {
  variants: {
    concealed: {
      true: "opacity-0",
      false: "group-hover/item:opacity-0 group-focus-within/item:opacity-0",
    },
  },
  defaultVariants: { concealed: false },
});

export const historyEntryMenuBtn = cva(
  "absolute right-0 rounded p-1 text-subtle transition-opacity hover:bg-panel-hover",
  {
    variants: {
      revealed: {
        true: "opacity-100",
        false:
          "opacity-0 group-hover/item:opacity-100 group-focus-within/item:opacity-100 focus-visible:opacity-100",
      },
    },
    defaultVariants: { revealed: false },
  },
);
